import React from "react";
import { useSelector } from "react-redux";
import {
  selectTabData,
  selectTabLoading,
} from "../../../../../../features/dynamicSlice";
import { MdPeople } from "react-icons/md";

const LatestAdmissionOrdersCard = ({ branchIds, startDate, endDate }) => {
  const latestOrdersCount = useSelector((state) => {
    let total = 0;
    const data = selectTabData(state, "latestAdmissionOrders");

    if (!data || !data.branches) return total;

    if (branchIds.includes("all")) {
      data.branches.forEach((branch) => {
        if (branch.latestOrdersCount) {
          total += Number(branch.latestOrdersCount);
        }
      });
    } else {
      branchIds.forEach((branchId) => {
        const branch = data.branches.find((b) => b.branchId === branchId);
        if (branch && branch.latestOrdersCount) {
          total += Number(branch.latestOrdersCount);
        }
      });
    }

    return total;
  });

  const loading = useSelector((state) =>
    selectTabLoading(state, "latestAdmissionOrders")
  );

  return (
    <div className="bg-gradient-to-br from-green-600 via-emerald-600 to-lime-500 text-white rounded-xl shadow-xl p-6 transform hover:scale-105 transition-transform duration-300 ease-in-out w-[20rem]">
      <div className="flex items-center justify-between mb-4">
        <h4 className="text-lg font-semibold uppercase tracking-wide">
          Total Admissions
        </h4>
        <MdPeople className="text-2xl" />
      </div>
      <div>
        {loading ? (
          <p className="text-sm animate-pulse">Loading...</p>
        ) : (
          <p className="text-3xl font-bold">{latestOrdersCount}</p>
        )}
      </div>
    </div>
  );
};

export default LatestAdmissionOrdersCard;
